import React, { useEffect } from "react";

// routing
import { NavLink as Link } from "react-router-dom";

// alert
import { warning } from "../../util/Alert";

import { useAccess, FEATURES } from "../../hooks/useAccess";

// redux
import { useDispatch } from "react-redux";

// types
import { logoutAdmin } from "../../store/admin/action";

//MUI
import { makeStyles } from "@material-ui/core";

// jquery
import $ from "jquery";

const useStyles = makeStyles(() => ({
  navLink: {
    "&.active": {
      color: "#1976d2 !important",
      fontWeight: 500,
      fontSize: 16,
    },
    "&.active span": {
      color: "#1976d2 !important",
      fontWeight: 900,
    },
  },
}));

const Navbar = () => {
  const classes = useStyles();

  const dispatch = useDispatch();

  const handleLogout = () => {
    const data = warning();
    data.then((isLogout) => {
      if (isLogout) dispatch(logoutAdmin());
    });
  };

  // Replace feather icons after every render (needed for conditionally rendered elements)
  useEffect(() => {
    if (window.feather) {
      window.feather.replace();
    }
  });

  const { canView, isSuperAdmin } = useAccess();
  return (
    <>
      <div className="page-sidebar">
        <Link to="/admin/dashboard">
          <span className="logo text-danger">VibeLynk</span>
        </Link>
        <ul className="list-unstyled accordion-menu">
          <li
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Dashboard"
          >
            <Link to="/admin/dashboard" className={`${classes.navLink}`}>
              <span className="sidenav__icon">
                <i data-feather="activity"></i>
              </span>
              Dashboard
            </Link>
          </li>

          <li
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Users"
            className="pointer-cursor"
          >
            <a
              href="#"
              className="add-collapse-margin"
              style={{ marginLeft: 0 }}
              onClick={(e) => e.preventDefault()}
            >
              <span className="sidenav__icon">
                <i data-feather="users"></i>
              </span>
              Users
              <i className="fas fa-chevron-right dropdown-icon"></i>
            </a>
            <ul className="">
              {canView(FEATURES.USERS) && (
                <li>
                  <Link to="/admin/user" className={`${classes.navLink}`}>
                    <i className="far fa-circle"></i>Users
                  </Link>
                </li>
              )}
              {canView(FEATURES.USERS) && (
                <li>
                  <Link to="/admin/svipUsers" className={`${classes.navLink}`}>
                    <i className="far fa-circle"></i>SVIP Users
                  </Link>
                </li>
              )}
              {canView(FEATURES.USERS) && (
                <li>
                  <Link
                    to="/admin/userReferrals"
                    className={`${classes.navLink}`}
                  >
                    <i className="far fa-circle"></i>User Referrals
                  </Link>
                </li>
              )}
              {canView(FEATURES.BANNED_USERS) && (
                <li>
                  <Link
                    to="/admin/bannedUsersFromApp"
                    className={`${classes.navLink}`}
                  >
                    <i className="far fa-circle"></i>Banned Users
                  </Link>
                </li>
              )}
              {canView(FEATURES.BANNED_DEVICES) && (
                <li>
                  <Link
                    to="/admin/bannedUsersFromApsp"
                    className={`${classes.navLink}`}
                  >
                    <i className="far fa-circle"></i>Banned Devices
                  </Link>
                </li>
              )}
              {canView(FEATURES.WHITELISTED_DEVICES) && (
                <li>
                  <Link
                    to="/admin/whiteListedDevices"
                    className={`${classes.navLink}`}
                  >
                    <i className="far fa-circle"></i>White-listed Devices
                  </Link>
                </li>
              )}
            </ul>
          </li>
          <li
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Live"
            className="pointer-cursor"
          >
            <a
              href="#"
              className="add-collapse-margin"
              style={{ marginLeft: 0 }}
              onClick={(e) => e.preventDefault()}
            >
              <span className="sidenav__icon">
                <i data-feather="radio"></i>
              </span>
              Live
              <i className="fas fa-chevron-right dropdown-icon"></i>
            </a>
            <ul className="">
              {canView(FEATURES.PARTY_ROOM) && (
                <li>
                  <Link to="/admin/partyRoom" className={`${classes.navLink}`}>
                    <i className="far fa-circle"></i>Party Room
                  </Link>
                </li>
              )}
              {canView(FEATURES.VIDEO_LIVE) && (
                <li>
                  <Link to="/admin/videoLive" className={`${classes.navLink}`}>
                    <i className="far fa-circle"></i>Video Live
                  </Link>
                </li>
              )}
              {canView(FEATURES.LIVE_BANNED_USERS) && (
                <li>
                  <Link
                    to="/admin/bannedUsersFromLive"
                    className={`${classes.navLink}`}
                  >
                    <i className="far fa-circle"></i>Banned Users
                  </Link>
                </li>
              )}
            </ul>
          </li>
          {canView(FEATURES.BANNER) && (
            <li data-bs-toggle="tooltip" data-bs-placement="top" title="Banner">
              <Link to="/admin/banner" className={`${classes.navLink}`}>
                <span className="sidenav__icon">
                  <i data-feather="image"></i>
                </span>
                Banner
              </Link>
            </li>
          )}

          {canView(FEATURES.PARTY_CHALLENGE) && (
            <li
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Party Challenge"
            >
              <Link to="/admin/partyChallenge" className={`${classes.navLink}`}>
                <span className="sidenav__icon">
                  <i data-feather="box"></i>
                </span>
                Party Challenge
              </Link>
            </li>
          )}
          {/* MARK: TODO: Check access */}
          <li
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Plan"
            className="pointer-cursor"
          >
            <a
              href="#"
              className="add-collapse-margin"
              style={{ marginLeft: 0 }}
              onClick={(e) => e.preventDefault()}
            >
              <span className="sidenav__icon">
                <i data-feather="users"></i>
              </span>
              Family Clan
              <i className="fas fa-chevron-right dropdown-icon"></i>
            </a>
            <ul className="">
              <li>
                <Link to="/admin/familyClans" className={`${classes.navLink}`}>
                  <i className="far fa-circle"></i>Family Clans
                </Link>
              </li>
              <li>
                <Link
                  to="/admin/familyClanLevels"
                  className={`${classes.navLink}`}
                >
                  <i className="far fa-circle"></i>Levels
                </Link>
              </li>
              <li>
                <Link
                  to="/admin/familyClanTasks"
                  className={`${classes.navLink}`}
                >
                  <i className="far fa-circle"></i>Tasks
                </Link>
              </li>
              <li>
                <Link
                  to="/admin/familyClanRanking"
                  className={`${classes.navLink}`}
                >
                  <i className="far fa-circle"></i>Family Ranking
                </Link>
              </li>
            </ul>
          </li>
          <li
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Plan"
            className="pointer-cursor"
          >
            <a
              href="#"
              className="add-collapse-margin"
              style={{ marginLeft: 0 }}
              onClick={(e) => e.preventDefault()}
            >
              <span className="sidenav__icon">
                <i data-feather="layout"></i>
              </span>
              Plan
              <i className="fas fa-chevron-right dropdown-icon"></i>
            </a>
            <ul className="">
              {canView(FEATURES.DIAMOND_PLAN) && (
                <li>
                  <Link
                    to="/admin/diamondPlan"
                    className={`${classes.navLink}`}
                  >
                    <i className="far fa-circle"></i>Diamond Plan
                  </Link>
                </li>
              )}
              {canView(FEATURES.VIP_PLAN) && (
                <li>
                  <Link to="/admin/vipPlan" className={`${classes.navLink}`}>
                    <i className="far fa-circle"></i>VIP Plan
                  </Link>
                </li>
              )}
            </ul>
          </li>
          <li
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Purchase Plan History"
            className="pointer-cursor"
          >
            <a
              href="#"
              className="add-collapse-margin"
              style={{ marginLeft: 0 }}
              onClick={(e) => e.preventDefault()}
            >
              <span className="sidenav__icon">
                <i data-feather="clock"></i>
              </span>
              Plan History
              <i className="fas fa-chevron-right dropdown-icon"></i>
            </a>
            <ul className="">
              {canView(FEATURES.DIAMOND_PLAN_HISTORY) && (
                <li>
                  <Link
                    to="/admin/diamondPlan/history"
                    className={`${classes.navLink}`}
                  >
                    <i className="far fa-circle"></i>Diamond Plan
                  </Link>
                </li>
              )}
              <li>
                <Link
                  to="/admin/vipPlan/history"
                  className={`${classes.navLink}`}
                >
                  <i className="far fa-circle"></i>VIP Plan
                </Link>
              </li>
              {canView(FEATURES.PURCHASE_TRANSACTIONS) && (
                <li>
                  <Link
                    to="/admin/purchaseTransactions"
                    className={`${classes.navLink}`}
                  >
                    <i className="far fa-circle"></i>Purchase Transactions
                  </Link>
                </li>
              )}
            </ul>
          </li>
          <li
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Gift"
            className="pointer-cursor"
          >
            <a
              href="#"
              className="add-collapse-margin"
              style={{ marginLeft: 0 }}
              onClick={(e) => e.preventDefault()}
            >
              <span className="sidenav__icon">
                <i data-feather="play"></i>
              </span>
              Game History
              <i className="fas fa-chevron-right dropdown-icon"></i>
            </a>
            <ul className="">
              {canView(FEATURES.GAME_TEEN_PATTI) && (
                <li>
                  <Link
                    to="/admin/teenPattiHistory"
                    className={`${classes.navLink}`}
                    onClick={() => localStorage.removeItem("GiftClick")}
                  >
                    <i className="far fa-circle"></i>Teen Patti
                  </Link>
                </li>
              )}
              {canView(FEATURES.GAME_VIBE_WHEEL) && (
                <li>
                  <Link
                    to="/admin/vibeWheelHistory"
                    className={`${classes.navLink}`}
                    onClick={() => localStorage.setItem("GiftClick", true)}
                  >
                    <i className="far fa-circle"></i>Vibe Wheel
                  </Link>
                </li>
              )}
              {canView(FEATURES.GAME_DIAMOND_RAIN) && (
                <li>
                  <Link
                    to="/admin/diamondRainHistory"
                    className={`${classes.navLink}`}
                    onClick={() => localStorage.setItem("GiftClick", true)}
                  >
                    <i className="far fa-circle"></i>Diamond Rain
                  </Link>
                </li>
              )}
              {canView(FEATURES.GAME_BAISHUN) && (
                <li>
                  <Link
                    to="/admin/baishunHistory"
                    className={`${classes.navLink}`}
                    onClick={() => localStorage.setItem("GiftClick", true)}
                  >
                    <i className="far fa-circle"></i>BAISHUN Games
                  </Link>
                </li>
              )}
            </ul>
          </li>
          <li
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Gift"
            className="pointer-cursor"
          >
            <a
              href="#"
              className="add-collapse-margin"
              style={{ marginLeft: 0 }}
              onClick={(e) => e.preventDefault()}
            >
              <span className="sidenav__icon">
                <i data-feather="gift"></i>
              </span>
              Gift
              <i className="fas fa-chevron-right dropdown-icon"></i>
            </a>
            <ul className="">
              {canView(FEATURES.GIFT_CATEGORIES) && (
                <li>
                  <Link
                    to="/admin/giftCategory"
                    className={`${classes.navLink}`}
                    onClick={() => localStorage.removeItem("GiftClick")}
                  >
                    <i className="far fa-circle"></i>Categories
                  </Link>
                </li>
              )}
              {canView(FEATURES.ALL_GIFTS) && (
                <li>
                  <Link
                    to="/admin/gift"
                    className={`${classes.navLink}`}
                    onClick={() => localStorage.setItem("GiftClick", true)}
                  >
                    <i className="far fa-circle"></i>All Gifts
                  </Link>
                </li>
              )}
            </ul>
          </li>

          <li
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Gift"
            className="pointer-cursor"
          >
            <a
              href="#"
              className="add-collapse-margin"
              style={{ marginLeft: 0 }}
              onClick={(e) => e.preventDefault()}
            >
              <span className="sidenav__icon">
                <i data-feather="loader"></i>
              </span>
              Store
              <i className="fas fa-chevron-right dropdown-icon"></i>
            </a>
            <ul className="">
              {canView(FEATURES.ENTRANCE_EFFECTS) && (
                <li>
                  <Link
                    to="/admin/admissionCar"
                    className={`${classes.navLink}`}
                    onClick={() => localStorage.removeItem("GiftClick")}
                  >
                    <i className="far fa-circle"></i>Admission Car
                  </Link>
                </li>
              )}
              {canView(FEATURES.AVATAR_FRAME) && (
                <li>
                  <Link
                    to="/admin/avatarFrame"
                    className={`${classes.navLink}`}
                    onClick={() => localStorage.setItem("GiftClick", true)}
                  >
                    <i className="far fa-circle"></i>Avatar Frame
                  </Link>
                </li>
              )}
              {canView(FEATURES.BACKGROUND) && (
                <li>
                  <Link
                    to="/admin/background"
                    className={`${classes.navLink}`}
                    onClick={() => localStorage.setItem("GiftClick", true)}
                  >
                    <i className="far fa-circle"></i>Background
                  </Link>
                </li>
              )}
              {canView(FEATURES.DIAMOND_SHOP) && (
                <li>
                  <Link
                    to="/admin/diamondShop"
                    className={`${classes.navLink}`}
                  >
                    <i className="far fa-circle"></i>Diamond Shop
                  </Link>
                </li>
              )}
            </ul>
          </li>

          <li
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Gift"
            className="pointer-cursor"
          >
            <a
              href="#"
              className="add-collapse-margin"
              style={{ marginLeft: 0 }}
              onClick={(e) => e.preventDefault()}
            >
              <span className="sidenav__icon">
                <i data-feather="award"></i>
              </span>
              Rewards
              <i className="fas fa-chevron-right dropdown-icon"></i>
            </a>
            <ul className="">
              {canView(FEATURES.SEND_REWARD) && (
                <li>
                  <Link to="/admin/sendReward" className={`${classes.navLink}`}>
                    <i className="far fa-circle"></i>Send Reward
                  </Link>
                </li>
              )}
              {canView(FEATURES.LEVEL_UP_REWARDS) && (
                <li>
                  <Link
                    to="/admin/levelUpRewards"
                    className={`${classes.navLink}`}
                  >
                    <i className="far fa-circle"></i>Level-up Rewards
                  </Link>
                </li>
              )}
              {canView(FEATURES.RECHARGE_REWARDS) && (
                <li>
                  <Link
                    to="/admin/rechargeRewards"
                    className={`${classes.navLink}`}
                  >
                    <i className="far fa-circle"></i>Recharge Rewards
                  </Link>
                </li>
              )}
              {canView(FEATURES.VIP_REWARDS) && (
                <li>
                  <Link to="/admin/vipRewards" className={`${classes.navLink}`}>
                    <i className="far fa-circle"></i>VIP Rewards
                  </Link>
                </li>
              )}
              {canView(FEATURES.DAILY_TASK_REWARDS) && (
                <li>
                  <Link to="/admin/vibePass" className={`${classes.navLink}`}>
                    <i className="far fa-circle"></i>Vibe Pass
                  </Link>
                </li>
              )}
            </ul>
          </li>

          <li
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Gift"
            className="pointer-cursor"
          >
            <a
              href="#"
              className="add-collapse-margin"
              style={{ marginLeft: 0 }}
              onClick={(e) => e.preventDefault()}
            >
              <span className="sidenav__icon">
                <i data-feather="star"></i>
              </span>
              Events
              <i className="fas fa-chevron-right dropdown-icon"></i>
            </a>
            <ul className="">
              <li>
                <Link to="/admin/weeklyStar" className={`${classes.navLink}`}>
                  <i className="far fa-circle"></i>Weekly Star
                </Link>
              </li>
            </ul>
          </li>
          {canView(FEATURES.STICKER) && (
            <li
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Sticker"
            >
              <Link to="/admin/sticker" className={`${classes.navLink}`}>
                <span className="sidenav__icon">
                  <i data-feather="smile"></i>
                </span>
                Sticker
              </Link>
            </li>
          )}
          {canView(FEATURES.THEME) && (
            <li data-bs-toggle="tooltip" data-bs-placement="top" title="Theme">
              <Link to="/admin/theme" className={`${classes.navLink}`}>
                <span className="sidenav__icon">
                  <i data-feather="image"></i>
                </span>
                Theme
              </Link>
            </li>
          )}
          {canView(FEATURES.AR_EFFECTS) && (
            <li
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="AR Effects"
            >
              <Link to="/admin/arEffects" className={`${classes.navLink}`}>
                <span className="sidenav__icon">
                  <i data-feather="zap"></i>
                </span>
                AR Effects
              </Link>
            </li>
          )}
          {canView(FEATURES.SONG) && (
            <li data-bs-toggle="tooltip" data-bs-placement="top" title="Song">
              <Link to="/admin/song" className={`${classes.navLink}`}>
                <span className="sidenav__icon">
                  <i data-feather="music"></i>
                </span>
                Song
              </Link>
            </li>
          )}
          <li
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="DiamondSeller"
            className="pointer-cursor"
          >
            <a
              href="#"
              className="add-collapse-margin"
              style={{ marginLeft: 0 }}
              onClick={(e) => e.preventDefault()}
            >
              <span className="sidenav__icon">
                <i data-feather="dollar-sign"></i>
              </span>
              Diamond Seller
              <i className="fas fa-chevron-right dropdown-icon"></i>
            </a>
            <ul className="">
              {canView(FEATURES.DIAMOND_SELLERS) && (
                <li>
                  <Link
                    to="/admin/diamondSeller"
                    className={`${classes.navLink}`}
                  >
                    <i className="far fa-circle"></i>Diamond Sellers
                  </Link>
                </li>
              )}
              {canView(FEATURES.DIAMOND_SELLER_SHOP) && (
                <li>
                  <Link
                    to="/admin/diamondSellerShop"
                    className={`${classes.navLink}`}
                  >
                    <i className="far fa-circle"></i>Diamond Shop
                  </Link>
                </li>
              )}
            </ul>
          </li>

          {canView(FEATURES.HASHTAG) && (
            <li
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Hashtag"
            >
              <Link to="/admin/hashtag" className={`${classes.navLink}`}>
                <span className="sidenav__icon">
                  <i data-feather="hash"></i>
                </span>
                Hashtag
              </Link>
            </li>
          )}

          {canView(FEATURES.LEVEL) && (
            <li data-bs-toggle="tooltip" data-bs-placement="top" title="Level">
              <Link to="/admin/level" className={`${classes.navLink}`}>
                <span className="sidenav__icon">
                  <i data-feather="bar-chart"></i>
                </span>
                Level
              </Link>
            </li>
          )}

          {canView(FEATURES.POST) && (
            <li data-bs-toggle="tooltip" data-bs-placement="top" title="Post">
              <Link to="/admin/post" className={`${classes.navLink}`}>
                <span className="sidenav__icon">
                  <i data-feather="maximize"></i>
                </span>
                Post
              </Link>
            </li>
          )}

          {canView(FEATURES.REELS) && (
            <li data-bs-toggle="tooltip" data-bs-placement="top" title="Video">
              <Link to="/admin/video" className={`${classes.navLink}`}>
                <span className="sidenav__icon">
                  <i data-feather="film"></i>
                </span>
                Reels
              </Link>
            </li>
          )}

          <li
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Report"
            className="pointer-cursor"
          >
            <a
              href="#"
              className="add-collapse-margin"
              style={{ marginLeft: 0 }}
              onClick={(e) => e.preventDefault()}
            >
              <span className="sidenav__icon">
                <i data-feather="flag"></i>
              </span>
              Reports
              <i className="fas fa-chevron-right dropdown-icon"></i>
            </a>
            <ul className="">
              {canView(FEATURES.REPORTED_USERS) && (
                <li>
                  <Link
                    to="/admin/reportedUser"
                    className={`${classes.navLink}`}
                  >
                    <i className="far fa-circle"></i>Reported Users
                  </Link>
                </li>
              )}
              {canView(FEATURES.REPORTED_MOMENTS) && (
                <li>
                  <Link
                    to="/admin/reportedMoments"
                    className={`${classes.navLink}`}
                  >
                    <i className="far fa-circle"></i>Reported Moments
                  </Link>
                </li>
              )}
              {canView(FEATURES.REPORTED_REELS) && (
                <li>
                  <Link
                    to="/admin/reportedReels"
                    className={`${classes.navLink}`}
                  >
                    <i className="far fa-circle"></i>Reported Reels
                  </Link>
                </li>
              )}
            </ul>
          </li>

          <li
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Complain"
            className="pointer-cursor"
          >
            <a
              href="#"
              className="add-collapse-margin"
              style={{ marginLeft: 0 }}
              onClick={(e) => e.preventDefault()}
            >
              <span className="sidenav__icon">
                <i data-feather="help-circle"></i>
              </span>
              Complain
              <i className="fas fa-chevron-right dropdown-icon"></i>
            </a>
            <ul className="">
              {canView(FEATURES.COMPLAIN_PENDING) && (
                <li>
                  <Link
                    to="/admin/pendingComplain"
                    className={`${classes.navLink}`}
                  >
                    <i className="far fa-circle"></i>Pending
                  </Link>
                </li>
              )}
              {canView(FEATURES.COMPLAIN_RESOLVED) && (
                <li>
                  <Link
                    to="/admin/solvedComplain"
                    className={`${classes.navLink}`}
                  >
                    <i className="far fa-circle"></i>Resolved
                  </Link>
                </li>
              )}
            </ul>
          </li>
          <li
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Redeem"
            className="pointer-cursor"
          >
            <a
              href="#"
              className="add-collapse-margin"
              style={{ marginLeft: 0 }}
              onClick={(e) => e.preventDefault()}
            >
              <span className="sidenav__icon">
                <i data-feather="key"></i>
              </span>
              Redeem
              <i className="fas fa-chevron-right dropdown-icon"></i>
            </a>
            <ul className="">
              {canView(FEATURES.REDEEM_PENDING) && (
                <li>
                  <Link
                    to="/admin/pendingRedeem"
                    className={`${classes.navLink}`}
                  >
                    <i className="far fa-circle"></i>Pending
                  </Link>
                </li>
              )}
              {canView(FEATURES.REDEEM_ACCEPTED) && (
                <li>
                  <Link
                    to="/admin/AcceptedRedeem"
                    className={`${classes.navLink}`}
                  >
                    <i className="far fa-circle"></i>Accepted
                  </Link>
                </li>
              )}
              {canView(FEATURES.REDEEM_DECLINED) && (
                <li>
                  <Link
                    to="/admin/declineRedeem"
                    className={`${classes.navLink}`}
                  >
                    <i className="far fa-circle"></i>Declined
                  </Link>
                </li>
              )}
              {canView(FEATURES.REDEEM_PAYMENT_METHODS) && (
                <li>
                  <Link
                    to="/admin/paymentMethod"
                    className={`${classes.navLink}`}
                  >
                    <i className="far fa-circle"></i>Payment Methods
                  </Link>
                </li>
              )}
            </ul>
          </li>

          {canView(FEATURES.DEACTIVATION) && (
            <li
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Google Ad"
            >
              <Link
                to="/admin/deactivationRequests"
                className={`${classes.navLink}`}
              >
                <span className="sidenav__icon">
                  <i data-feather="user-x"></i>
                </span>
                Deactivation
              </Link>
            </li>
          )}

          {canView(FEATURES.GOOGLE_AD) && (
            <li
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Google Ad"
            >
              <Link to="/admin/advertisement" className={`${classes.navLink}`}>
                <span className="sidenav__icon">
                  <i data-feather="book"></i>
                </span>
                Google Ad
              </Link>
            </li>
          )}
          {canView(FEATURES.SETTINGS) && (
            <li
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Setting"
            >
              <Link to="/admin/Setting" className={`${classes.navLink}`}>
                <span className="sidenav__icon">
                  <i data-feather="settings"></i>
                </span>
                Setting
              </Link>
            </li>
          )}
          <li data-bs-toggle="tooltip" data-bs-placement="top" title="Profile">
            <Link to="/admin/profile" className={`${classes.navLink}`}>
              <span className="sidenav__icon">
                <i data-feather="user"></i>
              </span>
              Profile
            </Link>
          </li>
          <li data-bs-toggle="tooltip" data-bs-placement="top" title="Security">
            <Link to="/admin/security" className={`${classes.navLink}`}>
              <span className="sidenav__icon">
                <i data-feather="lock"></i>
              </span>
              Security
            </Link>
          </li>
          {canView(FEATURES.ADMIN_MANAGEMENT) && (
            <li
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Profile"
            >
              <Link
                to="/admin/adminManagement"
                className={`${classes.navLink}`}
              >
                <span className="sidenav__icon">
                  <i data-feather="user-check"></i>
                </span>
                Admin Management
              </Link>
            </li>
          )}
          <li
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Redeem"
            className="pointer-cursor"
          >
            <a
              href="#"
              className="add-collapse-margin"
              style={{ marginLeft: 0 }}
              onClick={(e) => e.preventDefault()}
            >
              <span className="sidenav__icon">
                <i data-feather="hard-drive"></i>
              </span>
              Backend Management
              <i className="fas fa-chevron-right dropdown-icon"></i>
            </a>
            <ul className="">
              {canView(FEATURES.BACKEND_MAKE_VIP) && (
                <li>
                  <Link
                    to="/admin/backend-management/makeVIP"
                    className={`${classes.navLink}`}
                  >
                    <i className="far fa-circle"></i>Make VIP
                  </Link>
                </li>
              )}
              {canView(FEATURES.BACKEND_DIAS_APP_PURCHASE) && (
                <li>
                  <Link
                    to="/admin/backend-management/diasAppPurchase"
                    className={`${classes.navLink}`}
                  >
                    <i className="far fa-circle"></i>Dias App Purchase
                  </Link>
                </li>
              )}

              {isSuperAdmin || canView(FEATURES.BACKEND_GHOST_ACCOUNTS) ||
              canView(FEATURES.BACKEND_RESTRICTED_ACCOUNTS) ||
              canView(FEATURES.BACKEND_SUSPICIOUS_GIFT_PAIRS) ||
              canView(FEATURES.BACKEND_FACE_REVIEWS) ? (
                <div className="mt-4 mb-2">
                  <span className="ms-4"> User Management </span>
                </div>
              ) : null}
              {canView(FEATURES.BACKEND_GHOST_ACCOUNTS) && (
                <li>
                  <Link
                    to="/admin/backend-management/ghostAccounts"
                    className={`${classes.navLink}`}
                  >
                    <i className="far fa-circle"></i>Ghost Accounts
                  </Link>
                </li>
              )}
              {canView(FEATURES.BACKEND_RESTRICTED_ACCOUNTS) && (
                <li>
                  <Link
                    to="/admin/backend-management/restrictedAccounts"
                    className={`${classes.navLink}`}
                  >
                    <i className="far fa-circle"></i>Restricted Accounts
                  </Link>
                </li>
              )}
              {(isSuperAdmin || canView(FEATURES.BACKEND_SUSPICIOUS_GIFT_PAIRS)) && (
                <li>
                  <Link
                    to="/admin/backend-management/suspiciousGiftPairs"
                    className={`${classes.navLink}`}
                  >
                    <i className="far fa-circle"></i>Suspicious Gift Pairs
                  </Link>
                </li>
              )}
              {(isSuperAdmin || canView(FEATURES.BACKEND_FACE_REVIEWS)) && (
                <li>
                  <Link
                    to="/admin/backend-management/livenessFaceReviews"
                    className={`${classes.navLink}`}
                  >
                    <i className="far fa-circle"></i>Liveness Face Reviews
                  </Link>
                </li>
              )}
              {(isSuperAdmin || canView(FEATURES.BACKEND_FACE_REVIEWS)) && (
                <li>
                  <Link
                    to="/admin/backend-management/livenessAttempts"
                    className={`${classes.navLink}`}
                  >
                    <i className="far fa-circle"></i>Liveness Attempts
                  </Link>
                </li>
              )}
              {canView(FEATURES.BACKEND_RESTRICTED_ACCOUNTS) && (
                <li>
                  <Link
                    to="/admin/backend-management/dailyTaskRestrictions"
                    className={`${classes.navLink}`}
                  >
                    <i className="far fa-circle"></i>Daily Task Restriction
                  </Link>
                </li>
              )}
              {(isSuperAdmin || canView(FEATURES.BACKEND_SUSPICIOUS_GIFT_PAIRS)) && (
                <li>
                  <Link
                    to="/admin/backend-management/userGiftPairAnalysis"
                    className={`${classes.navLink}`}
                  >
                    <i className="far fa-circle"></i>Gift-Pair Analysis
                  </Link>
                </li>
              )}
              {canView(FEATURES.BACKEND_RESTRICTED_ACCOUNTS) && (
                <li>
                  <Link
                    to="/admin/backend-management/outOfCountryUsers"
                    className={`${classes.navLink}`}
                  >
                    <i className="far fa-circle"></i>Out of Country Users
                  </Link>
                </li>
              )}
              {(isSuperAdmin || canView(FEATURES.BACKEND_IP_MANAGEMENT)) && (
                <li>
                  <Link
                    to="/admin/backend-management/ipManagement"
                    className={`${classes.navLink}`}
                  >
                    <i className="far fa-circle"></i>IP Management
                  </Link>
                </li>
              )}

              {canView(FEATURES.BACKEND_GAME_SETTINGS) ||
              canView(FEATURES.BACKEND_REOPEN_TREASURE_BOX) ? (
                <div className="mt-4 mb-2">
                  <span className="ms-4"> Game Management </span>
                </div>
              ) : null}
              {canView(FEATURES.BACKEND_GAME_SETTINGS) && (
                <li>
                  <Link
                    to="/admin/backend-management/gameSettings"
                    className={`${classes.navLink}`}
                  >
                    <i className="far fa-circle"></i>Game Settings
                  </Link>
                </li>
              )}
              {canView(FEATURES.BACKEND_REOPEN_TREASURE_BOX) && (
                <li>
                  <Link
                    to="/admin/backend-management/reopenTreasureBox"
                    className={`${classes.navLink}`}
                  >
                    <i className="far fa-circle"></i>Reopen Treasure Box
                  </Link>
                </li>
              )}
            </ul>
          </li>

          <li data-bs-toggle="tooltip" data-bs-placement="top" title="Profile">
            <Link
              to="/admin/actionsForApproval"
              className={`${classes.navLink}`}
            >
              <span className="sidenav__icon">
                <i data-feather="check-circle"></i>
              </span>
              Actions For Approval
            </Link>
          </li>

          <li data-bs-toggle="tooltip" data-bs-placement="top" title="Logout">
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                handleLogout();
              }}
              className="add-collapse-margin"
            >
              <i data-feather="log-out"></i>Logout
            </a>
          </li>
        </ul>
        <a
          href="#"
          id="sidebar-collapsed-toggle"
          style={{ opacity: 0, pointerEvents: "none" }}
          onClick={(e) => e.preventDefault()}
        >
          <i data-feather="arrow-right"></i>
        </a>
      </div>
    </>
  );
};
export default Navbar;
